import { takeEvery, put, call } from 'redux-saga/effects'
import { post, get } from "@modul-connect/shared/utils/ajax"

function* fetchLogCodes() {
  const logCodes = yield call(get, '/log/code-lookup')

  if(logCodes && logCodes.status === 'ok') {
      const data = logCodes.data;
      yield put({ type: 'LOG_CODES_FETCHED', data: data, total: data.length })
  }
  else {
    yield put({ type: 'FETCHING_LOG_CODES_FAILED' })
  }
}

function* fetchLogCodeProviders() {
  const logProviders = yield call(get, '/log/code-reservations')

  if(logProviders && logProviders.status === 'ok') {
      const data = logProviders.data;
      yield put({ type: 'LOG_PROVIDERS_FETCHED', data: data, total: data.length })
  }
  else {
    yield put({ type: 'FETCHING_LOG_PROVIDERS_FAILED' })
  }
}

function* addProvider({ fromCode, toCode, provider, section, description }) {
  const command = {
    fromCode,
    toCode,
    provider,
    section,
    description
  }

  const result = yield call(post, '/log/create-reservation', { body: JSON.stringify(command) }, 'query')
  if (result && result.status) {
    switch (result.status) {
      case 'ok':
        yield put({ type: 'PROVIDER_ADDED', data: { from_code: fromCode, to_code: toCode, provider, section, description } })
        return
      default:
        yield put({ type: 'ADDING_PROVIDER_FAILED', data: { from_code: fromCode, to_code: toCode, provider, section, description } })
    }
  }
}

function* updateProvider({ id, provider, section, description }) {
  const command = {
    id,
    provider,
    section,
    description
  }

  const result = yield call(post, '/log/update-reservation', { body: JSON.stringify(command) }, 'query')
  if (result && result.status) {
    switch (result.status) {
      case 'ok':
        yield put({ type: 'PROVIDER_UPDATED', data: { id, provider, section, description } })
        return
      default:
        yield put({ type: 'UPDATING_PROVIDER_FAILED', data: { id, provider, section, description } })
    }
  }
}

function* addCode({ code, description }) {
  const command = {
    code,
    description
  }

  const result = yield call(post, '/log/create-code-lookup', { body: JSON.stringify(command) }, 'query')
  if (result && result.status) {
    switch (result.status) {
      case 'ok':
        yield put({ type: 'LOG_CODE_ADDED', data: { code, description } })
        return
      default:
        yield put({ type: 'ADDING_LOG_CODE_FAILED', data: { code, description } })
    }
  }
}

function* updateCode({ code, description }) {
  const command = {
    code,
    description
  }

  const result = yield call(post, '/log/update-code-lookup', { body: JSON.stringify(command) }, 'query')
  if (result && result.status) {
    switch (result.status) {
      case 'ok':
        yield put({ type: 'LOG_CODE_UPDATED', data: { code, description } })
        return
      default:
        yield put({ type: 'UPDATING_LOG_CODE_FAILED', data: { code, description } })
    }
  }
}

export function* logSagas() {
  yield takeEvery('FETCH_LOG_CODES', fetchLogCodes)
  yield takeEvery('FETCH_LOG_PROVIDERS', fetchLogCodeProviders)
  yield takeEvery('ADD_LOG_PROVIDER', addProvider)
  yield takeEvery('UPDATE_LOG_PROVIDER', updateProvider)
  yield takeEvery('ADD_LOG_CODE', addCode)
  yield takeEvery('UPDATE_LOG_CODE', updateCode)
}